import React from 'react';
import PropTypes from 'prop-types';

import AvatarV2 from '../PlayerCard/ListViewComponents/AvatarV2';
import PlayerDetails from '../PlayerCard/ListViewComponents/PlayerDetails';
import Img from '../../Img';
import { MAIN_LABEL, WAITLIST_LABEL } from '../../../utils/eventConstants';

const InvitedPlayerCardV3 = (props) => {
    const { invite, hideRatings, showCheckbox, gridLayout, showRegStatus, isPtsEvent, isCurrentMemberAdmin, divisions } = props;
    const { inviteeName } = invite;
    const playerName = inviteeName?.split(' ');
    const player = {
        firstName: playerName?.length > 0 ? playerName[0] : '',
        lastName: playerName?.length > 1 ? playerName[1] : '',
    };
    const isWaitlist = divisions?.allowTeamOnWaitlist || divisions?.isWaitlisted;
    return (
        <div className={`utr-card player-card player-card-v3`}>
            <div className={`list-view`}>
                <div className="d-flex">
                    {showCheckbox && (
                        <div className="checkbox-wrapper">
                            <div className={`checkbox-check`}><Img src="/img/icons/checkmark-icon.svg" /></div>
                        </div>
                    )}
                    <div className="flex-grow">
                        <div className="row">
                            <div className={`col-12`}>
                                <div className="d-grid w-100" style={{ gridTemplateColumns: gridLayout.join(' ') }}>
                                    <div className={`d-flex aic oh`}>
                                        <div className={`values ellipsis`}>
                                            {isWaitlist ? WAITLIST_LABEL : MAIN_LABEL}
                                        </div>
                                    </div>
                                    <div className={`d-flex aic oh`}>
                                        <AvatarV2 player={player} />
                                        <PlayerDetails firstName={player.firstName} lastName={player.lastName} />
                                    </div>
                                    {(!hideRatings && (
                                        <>
                                            <div className={`d-flex aic`}>&nbsp;</div>
                                            <div className={`d-flex aic`}>&nbsp;</div>
                                        </>
                                    ))}
                                    {!!isPtsEvent && (
                                        <div className={`d-flex aic`}>&nbsp;</div>
                                    )}
                                    {isCurrentMemberAdmin && (
                                        <div className={`d-flex aic oh`}>
                                            <div className={`values ellipsis`} title={player.age}>
                                                {player.age}
                                            </div>
                                        </div>
                                    )}
                                    {showRegStatus && (
                                        <div className={`d-flex aic oh`}>
                                            <div className={`values orange`}>
                                                Invited
                                            </div>
                                        </div>
                                    )}
                                    {isCurrentMemberAdmin && (
                                        <div className={`d-flex aic oh`}>
                                            &nbsp;
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={`bookmark`} />
                </div>
            </div>
        </div>
    );
};

InvitedPlayerCardV3.propTypes = {
    invite: PropTypes.objectOf({
        inviteeName: PropTypes.string.isRequired,
    }).isRequired,
    hideRatings: PropTypes.bool,
    isCurrentMemberAdmin: PropTypes.bool,
    showCheckbox: PropTypes.bool,
    isPtsEvent: PropTypes.bool,
};

InvitedPlayerCardV3.defaultProps = {
    hideRatings: false,
    isCurrentMemberAdmin: false,
    showCheckbox: false,
    isPtsEvent: false,
};

export default InvitedPlayerCardV3;
